export default __webpack_public_path__ + "static/media/cana.b043624c.svg";